import { Component } from '@angular/core';
import { OrderService } from './services/order.service';
import { OnInit } from '@angular/core';
import {ProductService} from "./services/product.service";
import {Product} from "./model/Product";
import {Type} from "./model/Type";
import {TypeAndProductsToDisplay} from "./model/TypeAndProductsToDisplay";
import {Router} from '@angular/router';
import {Photo} from "./model/Photo";
import {PhotoService} from "./services/photo.service";
import {ModalComponent} from "./components/modal-component";
import {TypeService} from "./services/type.service";
import {environment} from "../environments/environment";
import {ToastyConfig, ToastyService} from "ng2-toasty";
import {AuthenticationService} from "./services/authentication.service";

@Component({
    selector: 'app-admin-manage-products',
    templateUrl: './manage-products.component.html',
    /*styleUrls: ['./app.component.css'],*/
    providers: [ProductService]
})

export class ManageProductsComponent implements OnInit {
    ngOnInit(): void {
        //this.getOrder();
        this.getListTypes();
        this.getListProducts(this.loadActives);
        this.resetProduct();
    }
    title = 'My Order App';

    constructor(private productService : ProductService,
                private photoService : PhotoService,
                private typeService : TypeService,
                private toastyService:ToastyService,
                private toastyConfig: ToastyConfig,
                private router: Router,
                private authenticateService: AuthenticationService) {
        this.toastyConfig.theme = 'bootstrap'
    }
    order = null;
    listProducts: Product[];
    listTypes: Type[];
    listTypeAndProductsToDisplay: TypeAndProductsToDisplay[] = [];
    productEdit:Product;
    photoEdit: Photo;
    photoIsModifiable: boolean = false;
    active: any[][] = [];
    loadActives: boolean = false;
    imageBaseUri: string = environment.imageBaseUri;
    instantPaiementApi: string = environment.instantPaiementApi;

    getToken() {
        return this.authenticateService.getToken();
    }

    addOrUpdateProduct(modal: ModalComponent): void {
        this.productEdit.photo = this.photoEdit;
        if(this.productEdit.id) {
            this.productService.modifyProduct(this.productEdit)
                .then(
                    product  => {
                        modal.hide();
                        this.getListProducts(this.loadActives);},
                    error =>  {
                        if(error.json().error.code == 400) {
                            this._addToast("error", error.json().error.message);
                        } else {
                            this._addToast("error","Une erreur s'est produite. Le produit n'a pas été enregistré.");
                        }
                    });
        } else {
            if(!this.productEdit.name) {
                this._addToast("error", "Le nom est obligatoire");
            } else if(!this.productEdit.stock) {
                this._addToast("error", "Le stock est obligatoire");
            } else if(!this.productEdit.photo || !this.productEdit.photo.id) {
                this._addToast("error", "Le photo est obligatoire");
            } else if(!this.productEdit.type || !this.productEdit.type.id) {
                this._addToast("error", "Le type est obligatoire");
            } else {
                this.productService.addProduct(this.productEdit)
                    .then(
                        product => {
                            modal.hide();
                            this.getListProducts(this.loadActives);
                        },
                        error => {
                            if (error.json().error.code == 400) {
                                this._addToast("error", error.json().error.message);
                            } else {
                                this._addToast("error", "Une erreur s'est produite. Le produit n'a pas été enregistré.");
                            }
                        });
            }
        }

    }

    cancelAdd(modal: ModalComponent) : void {
        if(!this.productEdit.id) {
            //Cancel Add =  remove the new image if exists
            if(this.photoEdit.id) {
                this.photoService.removePhoto(this.photoEdit.id).then((listProducts) => {
                    //console.error("taille dans le app.component = " + listProducts);

                }, (error) => {
                    console.error(error);
                });
            }
        }

        modal.hide();
    }

    modifyImage(isModifiable): void {
        this.photoIsModifiable = isModifiable;
    }

    resetProduct() {
        this.productEdit = new Product();
        this.productEdit.active = true;
        this.productEdit.type = new Type();
        this.photoEdit = new Photo();
    }

    getListProducts(displayActives : boolean): void {
        this.listTypeAndProductsToDisplay = [];
        this.productService.getListProducts(displayActives).then((listProducts) => {
            //console.error("taille dans le app.component = " + listProducts);
            this.listProducts = listProducts;
            for(let product of listProducts) {
                let currentType = product.type;
                if(this.listTypeAndProductsToDisplay.hasOwnProperty(currentType.order) ) {
                    this.listTypeAndProductsToDisplay[currentType.order].listProducts.push(product);
                } else {
                    let newObject: TypeAndProductsToDisplay = {type : currentType, listProducts: [product]};
                    this.listTypeAndProductsToDisplay[currentType.order] = newObject;
                }
            }
        }, (error) => {
            console.error(error);
        });

    }

    getListTypes(): void {
        this.typeService.getListTypes().then((listTypes) => {
            this.listTypes = listTypes
        }, (error) => {
            console.error(error);
        })
    }

    modifyProduct(mProduct: Product, modal: ModalComponent) {
        this.productEdit = mProduct;
        this.photoEdit = mProduct.photo;
        modal.show();
    }

    createProduct(modal: ModalComponent): void {
        this.resetProduct();
        modal.show();
    }

    editProduct(id: number): void {
        this.router.navigate(["/admin-edit-product/" + id]);
    }

    imageUploaded(event) {
        let serverResponse = event.serverResponse;
        let response = JSON.parse(serverResponse._body);

        let result = response.result;
        let idPhoto = response.id;
        let urlPhoto = response.url;
        if(result) {
            this.photoEdit.id = idPhoto;
            this.photoEdit.url = urlPhoto;
        } else {
            this._addToast("error", response.error);
        }
    }

    imageRemoved(event) {
        console.log("imageRemoved : " + JSON.stringify(event));
        let serverResponse = event.serverResponse;
        let response = JSON.parse(serverResponse._body);

        let idPhotoToDelete = response.id;

        if(idPhotoToDelete != null) {
            this.photoService.removePhoto(idPhotoToDelete).then((listProducts) => {
                //console.error("taille dans le app.component = " + listProducts);

            }, (error) => {
                console.error(error);
            });
        }

    }

    changeLoadActives(): void {
        this.loadActives = !this.loadActives;

        this.getListProducts(this.loadActives);
    }

    private _addToast(type: string, message: string) {
        // Just add default Toast with title only
        if(type === "error") {
            this.toastyService.error(message);
        } else {
            this.toastyService.default(message);
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/manage-products.component.ts